{
    "roadmap": {
        "common": {
            "openAll": "Otevřít vše",
            "closeAll": "Zavřít vše",
            "openorCloseTitle": "Otevřít/Zavřít všechny akordeony"
        },
        "nextGen": {
            "nextGenTitle": "NextGen IT",
            "nextGenDesc": "Co je NextGen IT: Přináší automatizaci IT koncovým uživatelům a rychleji řeší problémy.",
            "acc1Title": "V produkci",
            "prodItem1": "Integrace KB článků: 300+ KB článků umožňujících samostatné řešení IT",
            "prodItem2": "Řešení Self-Healing: Více než 18 vzdálených skriptů k dispozici pro řešení problémů.",
            "prodItem3": "Vytváření incidentů: Zajišťuje přesné a rychlejší řešení prostřednictvím automatizovaného zaznamenávání incidentů.",
            "prodItem4": "Chat s živým agentem (lidským agentem): MyHelp umožňuje uživatelům chatovat s lidským agentem z AI asistenta",
            "acc2Title": "Ve vývoji",
            "devItem1": "Plánování zpětného volání (únor - 2026): Naplánujte zpětné volání IT podpory v čase, který vám vyhovuje",
            "devItem2": "Inteligentní směrování (únor - 2026): Směrujte tikety na správný tým řešitelů pro rychlejší podporu",
            "acc3Title": "V backlogu",
            "backItem1": "Agent pro řešení problémů PKI: Integrace MyHelp s agentem pro řešení problémů PKI k řešení problémů s certifikáty",
            "backItem2": "Plánování schůzek v centru pro návštěvy přímo prostřednictvím MyHelp"
        },
        "corporate": {
            "title": "Corporate",
            "desc": "Corporate je odpovědný za správu podnikových aplikací, HR platforem, které podporují pracovní sílu a obchodní funkce.",
            "acc1Title": "V produkci",
            "prodItem1": "Aplikace založené na BU: 90+ aplikací s personalizací založenou na BU",
            "prodItem2": "Připnutí vlastních aplikací: Uživatelé si mohou personalizovat svůj MyHelp Dashboard připnutím vlastních aplikací",
            "prodItem3": "Dotazy na pracoviště: 100+ dotazů na pracoviště (kancelář, parkování, budovy)",
            "prodItem4": "Rezervace zasedacích místností s AI asistentem: Rychlá, zjednodušená rezervace zasedacích místností s integrací Gingco",
            "prodItem5": "Dotazy HR: MyHelp odpovídá na 50 nejčastějších dotazů HR",
            "prodItem6": "Vyhledávání osob: Uživatelé mohou vyhledávat své kolegy z E.ON prostřednictvím MyHelp",
            "acc2Title": "Ve vývoji",
            "devItem1": "Onboarding aplikací na základě zavádění obchodních jednotek.",
            "devItem2": "AI asistent pro zasedací místnosti",
            "acc3Title": "V backlogu",
            "backItem1": "Přidání aplikací z AI asistenta a vlastních záložek: Přidání aplikací okamžitě prostřednictvím navrhovaných možností asistenta MyHelp"
        },
        "myGenius": {
            "title": "MyGenius",
            "desc": "Tato integrace vám pomůže najít relevantní školení a kurzy.",
            "acc1Title": "V produkci",
            "prodItem1": "Vyhledávání školení a kurzů: Najděte relevantní školení a kurzy pomocí MyHelp",
            "acc2Title": "Ve vývoji",
            "acc3Title": "V backlogu",
            "backItem1": "Personalizované učení: Personalizovaná doporučení školení na základě způsobilosti obchodní jednotky."
        },
        "myItOrder": {
            "title": "MyIT order",
            "desc": "Tato integrace vám pomůže najít relevantní položky IT objednávek a katalogy.",
            "acc1Title": "V produkci",
            "prodItem1": "Rychlé vyhledávání v katalogu IT objednávek: Rychle vyhledejte a objednejte své IT z MyHelp",
            "prodItem2": "Povolení a zrušení přístupu k softwaru: Povolení nebo zrušení přístupu k softwaru při navigaci z MyHelp.",
            "acc2Title": "Ve vývoji",
            "devItem1": "Přehled nákladů na IT aktiva: MyHelp zobrazí přehled nákladů na vaše IT aktiva",
            "acc3Title": "V backlogu",
            "backItem1": "Centrální schvalování objednaných položek"
        },
        "compass": {
            "title": "Compass",
            "desc": "Tato integrace vám pomůže najít komunitu, informace o novinkách a oznámení, které jsou sdíleny na intranetu.",
            "acc1Title": "V produkci",
            "prodItem1": "Bude vydáno do 28. února 2026",
            "acc2Title": "Ve vývoji",
            "devItem1": "Vyhledávání Compass (únor – 2026): Uživatelé E.ON budou moci vyhledávat data své komunity v MyHelp E.ON Search",
            "devItem2": "MyHelp-Compass AI asistent (v průběhu) (únor – 2026): Umožnění uživatelům E.ON přístup k datům komunity prostřednictvím AI asistenta MyHelp",
            "acc3Title": "V backlogu"
        },
        "chatProjectData": {
            "title": "Chat s daty projektu",
            "desc": "Tato integrace vám umožní onboardovat data projektu z confluence, sharepointu atd.",
            "acc1Title": "V produkci",
            "prodItem1": "Projekty Confluence One Billing a DSODP jsou onboardovány",
            "prodItem2": "SharePoint stránky – stránka projektu DSODP je onboardována",
            "acc2Title": "Ve vývoji",
            "devItem1": "Práce na integraci dat projektu Nautilus je aktuálně v průběhu.",
            "acc3Title": "V backlogu"
        },
        "personalization": {
            "title": "Personalizace",
            "acc1Title": "V produkci",
            "prodItem1": "Vícejazyčné: podporuje 4 jazyky (angličtina, němčina, švédština, rumunština)",
            "prodItem2": "Více témat: umožňuje každé obchodní jednotce nebo regionu používat vlastní branding, což zlepšuje známost a přijetí.",
            "prodItem3": "5 dalších nových jazyků v beta profilu (čeština, italština, maďarština, nizozemština a polština)",
            "acc2Title": "Ve vývoji",
            "devItem1": "Specifické pro zdroj dat (15. února – 2026): poskytuje více cílené a kontextově vědomé odpovědi tím, že čerpá informace z vybraných zdrojů dat uživatele.",
            "acc3Title": "V backlogu"
        },
        "technicalEnablement": {
            "title": "Technické povolení",
            "acc1Title": "V produkci",
            "prodItem1": "Zabezpečení a pozorovatelnost zajišťují ochranu dat na podnikové úrovni, soulad a výkon, a také umožňují bezpečný, spolehlivý a hladký chod operací",
            "prodItem2": "Dashboardy KPI a adopce (Power BI)<br /> Poskytují jasnou viditelnost do využití, realizace hodnoty a obchodního dopadu prostřednictvím dashboardů KPI",
            "acc2Title": "Ve vývoji",
            "devItem1": "Pracovní postup multiagentů do 15. března 2026: Umožňuje více úmyslné konverzace, které nejen zlepšují relevanci odpovědí, ale také provádějí end-to-end pro uživatele.",
            "acc3Title": "V backlogu",
            "backItem1": "Rámec MCP (Backlog): <br /> Poskytuje základ pro orchestraci a koordinaci AI agentů napříč E.ON, umožňující škálovatelné a spolupracující podnikové AI schopnosti."
        }
    }
}